// extracted by mini-css-extract-plugin
module.exports = {"addBtn":"Map_addBtn__l7jcL","imsBtn":"Map_imsBtn__1TvQA","sfBtn":"Map_sfBtn__3UVKa"};